const Modal = (props) => {
	return (
		<div
			className="modal fade"
			id="exampleModal"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="exampleModalLabel">
							{props.title}
						</h5>
						<button
							type="button"
							className="btn btnClose"
							data-bs-dismiss="modal"
							aria-label="Close"
						>
							<i className="bx bx-x"></i>
						</button>
					</div>
					<div className="modal-body">{props.children}</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-danger" data-bs-dismiss="modal">
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Modal;
